module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-content"
  }, [_vm._t("noscroll"), _vm._v(" "), _c('div', {
    directives: [{
      name: "alloytouch",
      rawName: "v-alloytouch",
      value: ({
        options: _vm.options,
        methods: {
          touchStart: _vm.touchStart,
          animationEnd: _vm.onAnimationEnd,
          initAlloyTouch: _vm.initAlloyTouch
        }
      }),
      expression: "{options: options,methods:{touchStart:touchStart, animationEnd:onAnimationEnd,initAlloyTouch: initAlloyTouch}}"
    }],
    ref: "scroller",
    staticClass: "scroller"
  }, [_vm._t("default")], 2)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07cfe7be","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-content/index.vue
// module id = 1017
// module chunks = 2